import queryParams from "./query";

const httpApiHostDebug = 'https://apiserver.solutions';
const httpApiHostRelease = 'https://apiserver.solutions';
const gameServerHostDebug = 'wss://28.stargame.games:4488/';
const gameServerHostRelease = 'wss://34.stargamegames.com:4488/';
const pvpServerHostDebug = 'wss://58.stargame.games:7274';
const pvpServerHostRelease = 'wss://30.stargamegames.com:7275';
const oneWalletApiHostDebug = 'https://onewallettest.asia.games';
const oneWalletApiHostRelease = 'https://onewallet.asia.games';
const oneWalletApiRowHostDebug = 'https://onewallettest.row.solutions';
const oneWalletApiRowHostRelease = 'https://onewallet.row.solutions';
const cashierApiHostRelease = 'https://ac.umbrella-corp.company:3334';
const cashierApiHostDebug = 'https://58.stargame.games:3334';

export const httpApiHost = () => {
    if (queryParams.httpApiHost) {
        return queryParams.httpApiHost;
    }
    return window.STARGAME_DEBUG_ ? httpApiHostDebug : httpApiHostRelease;
};

export const gameServerHost = () => {
    if (queryParams.gameServerHost) {
        return queryParams.gameServerHost;
    }
    if (window.location.hostname.includes('bigwinner.pro') ||
        window.location.hostname.includes('luckywinne.com')) {
        return "wss://gaming.bigwinner.pro:8082"
    }
    return window.STARGAME_DEBUG_ ? gameServerHostDebug : gameServerHostRelease;
};

export const pvpServerHost = () => {
    if (queryParams.pvpServerHost) {
        return queryParams.pvpServerHost;
    }
    if (queryParams.liveServerHost) {
        return queryParams.liveServerHost;
    }
    if (window.location.hostname.includes('bigwinner.pro') ||
        window.location.hostname.includes('luckywinne.com')) {
        return "wss://live.bigwinner.pro:8083"
    }
    return window.STARGAME_DEBUG_ ? pvpServerHostDebug : pvpServerHostRelease;
};

export const oneWalletApiHost = (auth) => {
    if (queryParams.oneWalletApiHost) {
        return queryParams.oneWalletApiHost;
    }

    const { uid, hallId } = auth;

    let debugHost = oneWalletApiHostDebug;
    let releaseHost = oneWalletApiHostRelease;

    if (window.location.host === "row.solutions") {
        debugHost = oneWalletApiRowHostDebug;
        releaseHost = oneWalletApiRowHostRelease;
    }

    if (hallId === 12279 || hallId === 15432) {

        if ([1219253, 1215310, 5799225, 5799226].indexOf(uid) !== -1) {
            return releaseHost;
        }

        return debugHost;
    }

    if (hallId === 11618) {

        if ([1144919, 1144920, 1589397, 1177524, 1320442, 1320443, 1320445,].indexOf(uid) !== -1) {
            return releaseHost;
        }

        return debugHost;
    }

    if (hallId === 13546) {
        if ([1621121, 1621122].indexOf(uid) !== -1) {
            return releaseHost;
        }

        return debugHost;
    }

    return window.STARGAME_DEBUG_ ? debugHost : releaseHost;
};

export const cashierApiHost = () => {
    if (queryParams.cashierApiHost) {
        return queryParams.cashierApiHost;
    }
    return window.STARGAME_DEBUG_ ? cashierApiHostDebug : cashierApiHostRelease;
};